import moment from "moment";
import {firestore} from "firebase";

export const fireStoreTimeStampToMMDDYY = (timeStamp: firestore.Timestamp) => {
    return moment(moment.utc(new Date(timeStamp.toDate()))).format(
        // 'yyy-MM-DD',
        'MM/DD/YYYY',
    );
};
